<template>
  <div>
    <v-card class="ma-5" elevation="0" v-if="maquinas.length > 0">
      <v-card-title class="mt-6 ml-6">
        <v-row align="center">
          <v-col cols="12" md="6" sm="12">
            <v-select
              prefix="MÁQUINA:"
              class="mb-5"
              dense
              @change="
                maquinaSeleccionada.maquina != '-' ? setMachine(maquinaSeleccionada.maquina) : null
              "
              v-model="maquinaSeleccionada"
              placeholder="Seleccionar máquina..."
              :items="maquinas_select"
              item-value="id_maquina"
              return-object
              color="primary"
            >
              <template v-slot:selection="{ item }">
                {{ item.maquina.toUpperCase() }}
              </template>
              <template v-slot:item="{ item }">
                {{ item.maquina.toUpperCase() }}
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" md="6" sm="12">
            <v-select
              id="version"
              v-model="versionAcumuladoVista"
              class="mb-5"
              dense
              :items="items"
              item-value="value"
              item-text="text"
            ></v-select>
          </v-col>
        </v-row>

      </v-card-title>
     

      <v-card-text class="mb-2">
        <!-- seleccionar franja -->
        <v-row>
          <v-col cols="12" md="5">
            <date-picker :labelFecha="'Fecha Inicio'" :labelHora="'Hora Inicio'" :tipo="1"></date-picker>
          </v-col>
          <v-col cols="12" md="5">
            <date-picker :labelFecha="'Fecha Fin'" :labelHora="'Hora Fin'" :tipo="2"></date-picker>
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-self-center">
            <v-btn block @click="buscar()">Buscar</v-btn>
          </v-col>
        </v-row>

        <!-- tabla con ciclos para moldeo y macheria -->
        <v-divider></v-divider>
        <v-container fluid v-if="mostrar_modal_historico">
          <multi-variable-line-chart 
            :id_maquina="this.maquinaSeleccionada.id_maquina"
            :available_variables="getVariablesAvailable()"
          >
          </multi-variable-line-chart />

        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import datePicker from "@/components/datePicker.vue";
import MultiVariableLineChart from "@/utils/MultiVariableLineChart.vue";

export default {
  name: "AccumulativeView",

  components: {
    datePicker,
    MultiVariableLineChart,
  },

  data() {
    return {
      versionAcumuladoVista: 2,
      items: [
        { text: "Versión 1", value: 1 },
        { text: "Versión 2", value: 2 },
      ],
      maquinas_select: [],
      maquinaSeleccionada: { maquina: null, id_maquina: -1 },

      mostrar_modal_historico: false,
      variables_posibles: [],
    };
  },

  computed: {
    ...mapState(["maquinas","versionAcumulado"]),
    ...mapGetters(["getMachine", "getInicio", "getFin"]),
  },

  methods: {
    ...mapActions(["setMachine", "setMaquinas", "SET_ACCUMULATIVE_VERSION"]),
    ...mapActions("utils", ["setInitDateFilter", "setEndDateFilter"]),

    async buscar() {
      console.log("vamos a buscar....")
      this.mostrar_modal_historico = false;

      this.setInitDateFilter(this.getInicio);
      this.setEndDateFilter(this.getFin);
      this.mostrar_modal_historico = true;

      //Debe traerse las variables mostrables para acumulacion


    },
    
    getVariablesAvailable() {
      // const salida = JSON.parse(JSON.stringify(this.maquinaSeleccionada.variables))
      //  return salida.filter(e=>e.para_acumulado==true)

      const salida = this.maquinaSeleccionada?.variables 
      ? JSON.parse(JSON.stringify(this.maquinaSeleccionada.variables)) 
      : [];
    

      return salida.filter(e => e.para_acumulado === true);



    }
  },

  mounted() {
    if (this.maquinas.length > 0) {
      this.maquinas_select = this.maquinas.filter(
        (m) => m.id_maquina == 2 || m.id_maquina == 3 || m.id_maquina == 6
      );

      this.setMachine("macheria");
      this.maquinaSeleccionada = this.getMachine;
    }
  },

  watch: {
    versionAcumuladoVista() {
      this.SET_ACCUMULATIVE_VERSION(this.versionAcumuladoVista)
    },
    // Ejecutado al cargar los datos iniciales de máquinas
    maquinas() {
      this.maquinas_select = this.maquinas.filter(
        (m) => m.id_maquina == 2 || m.id_maquina == 3 || m.id_maquina == 6
      );

      // this.setMachine("macheria");
      this.maquinaSeleccionada = this.getMachine;
      console.group("maquina")
      console.log(this.maquinaSeleccionada)
      console.groupEnd();

    },
  },
};
</script>

<style>
.overflow-x-auto {
  overflow-x: auto;
}
</style>
